export const COMPLIANCE_CHANGESET_GET_CHANGESET = 'COMPLIANCE_CHANGESET_GET_CHANGESET';
export const COMPLIANCE_CHANGESET_GET_CHANGESET_SUCCESS = 'COMPLIANCE_CHANGESET_GET_CHANGESET_SUCCESS';
export const COMPLIANCE_CHANGESET_GET_CHANGESET_FAIL = 'COMPLIANCE_CHANGESET_GET_CHANGESET_FAIL';

export const COMPLIANCE_CHANGESET_GET_CHANGESET_CLEAR = 'COMPLIANCE_CHANGESET_GET_CHANGESET_CLEAR';
